export default "__VITE_ASSET__DoKrZP0g__"